import { useEffect } from "react";
import { useQuery } from "@apollo/client";
import { clientEntities } from "@neonumy/api-clients";
import { LIST_CLIENT_TYPE_CHOICES } from "queries/entities/clients";
import { ListClientTypeChoices } from "queries/types/entities/clients";
import { onErrorGraphql } from "utils/onErrorGraphql";

export default function useGetClientTypeOptions() {
  const { data, error } = useQuery<ListClientTypeChoices>(LIST_CLIENT_TYPE_CHOICES, {
    client: clientEntities,
    fetchPolicy: "cache-first",
  });

  useEffect(() => {
    if (error) onErrorGraphql(error);
  }, [error]);

  const options =
    data?.listCategoryChoices?.map((item: LabelValueType) => ({
      label: item.label.charAt(0).toUpperCase() + item.label.slice(1),
      value: item.value,
    })) || [];

  return { options, error };
}
